import React from 'react'
import TextFieldUniversal from '../../../../validate/form/text/TextFieldUniversal'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setWriteOffActsQuery } from '../../../../../store/writeOffSlice'

const WriteOffActsFilterQuery = () => {

    const query = useSelector(state => state.writeOff.writeOffActs.query)
    const dispatch = useDispatch()

    const [value, setValue] = useState('')

  return (
    <TextFieldUniversal
        value={value}
        setValue={e => {
            // setValueForm(e)
            dispatch(setWriteOffActsQuery(e))
            setValue(e)
        }}
        // setValidate={setValidate}
        label={'Пошук'} 
        placeholder={'Введіть для пошуку'}
        validates={{
            isEmpty: true,
        }}
        forciblyValue={query}
        required={false}		
    />
  )
}

export default WriteOffActsFilterQuery